import { log } from './functions'

/**
 * UIHudSystem handles showing and hiding of global HUD elements like loading spinners and tips.
 */
export class UIHudSystem {
  private activeHuds: Map<string, any> = new Map()

  /**
   * Shows a HUD element by name.
   * @param name The name of the HUD element (e.g., 'Loading', 'SystemTips').
   * @param args Optional arguments for the HUD element.
   */
  public show(name: string, ...args: any[]): void {
    log(`[UIHudSystem] Showing HUD: ${name}`, ...args)
    // In a real implementation, this would trigger a Vue component or global state update.
    // For now, we track it to prevent null reference errors.
    this.activeHuds.set(name, args)
  }

  /**
   * Hides a HUD element by name.
   * @param name The name of the HUD element (e.g., 'Loading', 'SystemTips').
   */
  public hide(name: string): void {
    log(`[UIHudSystem] Hiding HUD: ${name}`)
    this.activeHuds.delete(name)
  }

  /**
   * Specifically handles the loading spinner ("菊花").
   */
  public showLoading(): void {
    this.show('Loading')
  }

  public hideLoading(): void {
    this.hide('Loading')
  }

  /**
   * Retrieves data from an active HUD element.
   * @param name The name of the HUD element.
   * @param isSingleton Optional boolean, used by some modules.
   * @returns The arguments passed when showing the HUD, or null if not active.
   */
  public getFromActiveHud(name: string, _isSingleton?: boolean): any {
    return this.activeHuds.get(name) || null
  }
}
